import type { OfferViewModel, Quote } from "@/api_client";

export const getProductPrice = (product: Quote): number | undefined => {
  return undefinedIfZero(product?.annualNetPrice ?? 0);
};

const undefinedIfZero = (value: number | undefined): number | undefined => {
  if (value === 0) {
    return undefined;
  }
  return value;
};

export const getOfferPrice = (offer: OfferViewModel): number => {
  if (!offer?.quotes) {
    return 0;
  }
  return offer.quotes.reduce(
    (total, product) => total + (getProductPrice(product) ?? 0),
    0,
  );
};
